import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import api from '../../services/api';
import Layout from '../../components/Layout';
import { Container } from 'react-bootstrap';
import TopBar from '../../components/TopBar';

const LeaveQuota = ({ token }) => {
  const [quotas, setQuotas] = useState([]);

  useEffect(() => {
    api.get('/leave/quotas')
      .then(res => setQuotas(res.data));
  }, []);

  return (
    <Layout>
        <TopBar title="Leave Quota" />
        


   <Container className="mt-4" fluid>
        <Table bordered striped className="mt-4">
        <thead>
            <tr>
            <th>Type</th><th>Allocated</th><th>Used</th><th>Balance</th>
            </tr>
        </thead>
        <tbody>
            {quotas.map((q, i) => (
            <tr key={i}>
                <td>{q.leave_type.name}</td>
                <td>{q.allocated}</td>
                <td>{q.used}</td>
                <td>{q.allocated - q.used}</td>
            </tr>
            ))}
        </tbody>
        </Table>
    </Container>
    </Layout>
  );
};

export default LeaveQuota;
